// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { UserGroups } from 'features/user_groups'

import { SettingsModalMemoryRouteShell } from './settings_modal_memory_route_shell'
import { ADMIN_GROUPS_BASE } from './settings_modal_user_groups_constants'

/**
 * User groups UI is routed under `/app/admin/user_groups` in the main app. Inside the settings
 * modal the browser stays on the host page (`?settings=…`), so we mount the same routes on a
 * dedicated MemoryRouter to keep list ↔ group management navigation working.
 */
export const SettingsModalUserGroupsShell = ({ memoryHistory }) => (
  <SettingsModalMemoryRouteShell
    basePath={ADMIN_GROUPS_BASE}
    component={UserGroups}
    memoryHistory={memoryHistory}
  />
)
